import React, { useContext } from "react";
import { QuoteContext } from "./QuoteContext";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const { step,  steps, resetQuoteForm } = useContext(QuoteContext);
  const totalSteps = steps.length;
  const navigate = useNavigate();

  return (
    <>
      <div className="bg-[#022A4A] text-white sticky top-0 left-0 w-full z-40">
        <div className="py-1 flex justify-between items-center px-5">
          <div className="flex-shrink-0">
            <img src="/images/cards/pacific.png" alt="Logo" className="sm:h-14 h-9 " />
          </div>

          <div className="flex-1 text-center">
            <div className="relative sm:w-[90%] w-[70%] mx-auto sm:mb-5 sm:mt-5 mt-3 ">
              <div className="h-2 bg-white w-full rounded"></div>
              <div
                className="absolute top-0 left-0 h-2 bg-orangeColor rounded"
                style={{ width: `${(step / totalSteps) * 100}%` }}
              ></div>
              <div
                className="absolute top-[-5px] h-4 w-4 bg-[#1C76BC] rounded-full border-4 border-orangeColor transition-transform"
                style={{ left: `calc(${(step / totalSteps) * 100}% - 8px)` }}
              ></div>
            </div>

            <div className="hidden sm:flex justify-between w-full mx-auto mt-3 text-sm">
              {steps.map((label, index) => (
                <div
                  key={index}
                  className={`text-center ${
                    index + 1 <= step ? "text-orangeColor font-bold" : "text-[#AAAAAA]"
                  }`}
                  style={{ width: `${100 / totalSteps}%` }}
                >
                  {label}
                </div>
              ))}
            </div>

            <div className="sm:hidden text-center text-orangeColor text-sm font-bold sm:mt-3 mt-1">
              {steps[step - 1]}
            </div>
          </div>

          <div>
            <button
              className="cursor-pointer  sm:text-2xl text-white mb-2 underline decoration-orangeColor underline-offset-[10px] uppercase"
              onClick={() => {
                resetQuoteForm(); // Reset all stored data
                window.location.reload();
                // navigate("/quote-version"); // Navigate user back to home page
              }}
            >
              Exit
            </button>
          </div>
        </div>

        <div className="w-full h-[2px] animate-pulse bg-gray-500"></div>
      </div>
    </>
  );
};

export default Header;